import React, { useEffect, useState } from "react";
import styles from "./EditEquipment.module.css";
import { useNavigate } from "react-router-dom";
import { Table, Select, Input } from "antd";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import ProgramsTab from "../../../../../components/ProgramsTab/ProgramsTab";
import { ReactComponent as CloseOutlined } from "../../../../../assets/images/cancel.svg";
import {
  Dropdown,
  InputField,
  TextComponent,
  SubmitButton,
  Modal
} from "../../../../../components";
import CheckBox from '../../../../../components/Checkbox/CheckBox';
import { Alert } from "antd";
import { max, min } from "moment/moment";
import { Card, List } from 'antd';


const data = [
  {
    title: 'Mixing',
  },
  {
    title: 'Oven',
  },
  {
    title: 'Proof',
  },
  {
    title: 'Chill',
  },
  {
    title: 'Assembly',
  },
  {
    title: 'Packaging',
  },
  {
    title: 'Make Up',
  },
];


const EditEquipment = () => {
  const navigate = useNavigate();
  const [MachineName, setMachineName] = useState("");
  const [MachineCategory, setMachineCategory] = useState("");
  const [MachineType, setMachineType] = useState("Manual");
  const [skillLevel, setSkillLevel] = useState("");
  const [weightCapacity, setWeightCapacity] = useState("");
  const [maxWeightCapacity, setMaxWeightCapacity] = useState("");
  const [minWeightCapacity, setMinWeightCapacity] = useState("");
  const [maxWeightCapacityUnit, setMaxWeightCapacityUnit] = useState("lbs");
  const [minWeightCapacityUnit, setMinWeightCapacityUnit] = useState("lbs");
  const [isModal, setIsModal] = useState(false);
  const [manParameter, setManParameter] = useState("");
  const [mandata, setManData] = useState("");
  const [autoParameter, setAutoParameter] = useState("");
  const [autoData, setAutoData] = useState("");
  const [autoValue, setAutoValue] = useState("");
  const [dueDay, setDueDay] = useState("")
  const [dataType, setDataType] = useState()


  // /   // Tabs for Automatic Machine Type
  const [programTabs, setProgramTabs] = useState([]);
  const [activeKey, setActiveKey] = useState(null);

  useEffect(() => {
    if (programTabs.length > 0) {
      setActiveKey(programTabs[programTabs.length - 1].key);
    }
  }, [programTabs]);


  useEffect(() => {
    // simulate API data
    const backendData = [
      {
        programName: "Program 1",
        parameters: [
          { parameters: "Bake Temperature (F)", data: "Numeric", value: "450" },
          { parameters: "Time (minutes)", data: "Numeric", value: "25" },
        ],
      },
      {
        programName: "Program 2",
        parameters: [
          { parameters: "Steam (seconds)", data: "Numeric", value: "45" },
        ],
      },
    ];

    const formattedTabs = backendData.map((item, index) => ({
      key: `program-${index + 1}`,
      label: item.programName,
      tableData: item.parameters,
    }));

    setProgramTabs(formattedTabs);
    if (formattedTabs.length > 0)
      setActiveKey(formattedTabs[0].key);
  }, []);


  const handleAddProgram = () => {
    const newKey = `program-${programTabs.length + 1}`;
    const newProgram = {
      key: newKey,
      label: `Program ${programTabs.length + 1}`,
      tableData: [],
    };
    setProgramTabs([...programTabs, newProgram]);
    setActiveKey(newKey);
  };

  const handleRemoveProgram = (key) => {
    const updated = programTabs.filter((t) => t.key !== key);
    setProgramTabs(updated);
    if (activeKey === key && updated.length > 0)
      setActiveKey(updated[updated.length - 1].key);
    else if (updated.length === 0)
      setActiveKey(null);
  };


  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };



  const [manualList, setManualList] = useState([
    {
      parameters: "Bake Temperature (Fahrenheit)",
      data: "Numeric",

    },
    {
      parameters: "Time (minutes)",
      data: "Numeric",

    },

  ]);

  const [autoList, setMAutoList] = useState([
    {
      parameters: "Bake Temperature (Fahrenheit)",
      data: "Numeric",
      value: "450",

    },
    {
      parameters: "Time (minutes)",
      data: "Numeric",
      value: "25",
    },

  ]);

  const manualColumns = [
    {
      title: "Parameters",
      dataIndex: "parameters",
      key: "parameters",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => (
        <div>
          <SubmitButton
            title={"Edit"}
            btnClass={styles.tableBtn}
            primary
          // onClick={() => navigate("/AddEquipment")}
          />
        </div>
      ),
    },

    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => (
        <div>
          <SubmitButton
            title={"remove"}
            btnClass={styles.tableBtn}
            secondary
          // onClick={() => navigate("/AddEquipment")}
          />
        </div>
      ),
    },

  ];

  const autoColumns = [
    {
      title: "Parameters",
      dataIndex: "parameters",
      key: "parameters",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },

    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => (
        <div>
          <SubmitButton
            title={"Edit"}
            btnClass={styles.tableBtn}
            primary
          // onClick={() => navigate("/AddEquipment")}
          />
        </div>
      ),
    },

    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => (
        <div>
          <SubmitButton
            title={"remove"}
            btnClass={styles.tableBtn}
            secondary
          // onClick={() => navigate("/AddEquipment")}
          />
        </div>
      ),
    },

  ];

  const options = [
    { id: 1, name: "Basic Info" },
    { id: 2, name: "Bakery Schedule" },
  ];

  const [focused, setFocused] = useState(options[0]);


  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Edit Equipment"}
        onSearch={(e) => console.log(e.target.value)}
        // onSubmit={() => navigate("/CreateNewStaffUser")}
        submitButtonText={" Save Equipment"}
        showBackIcon={true}
        showFilterIcon={false}
        showSubmitButton={true}
        showSearch={false}
      />
      <div className={styles.mainCont1}>
        <div className={styles.leftCont}>
          <InputField
            label={"Machine Name"}
            placeholder={"Enter Machine Name"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={MachineName}
            onChange={(e) => setMachineName(e.target.value)}
          />

          <div className={styles.TwoInputRow}>
            <Dropdown
              className={styles.inputNew}
              label={"Machine Category"}
              value={MachineCategory}
              labelStyle={{ fontSize: 18 }}
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              style={{ color: "black" }}
              options={[
                {
                  value: "Oven",
                  id: 1,
                },
              ]}
              onChange={(e) => setMachineCategory(e)}
            />
            <Dropdown
              className={styles.inputNew}
              label={"Machine Type"}
              value={MachineType}
              labelStyle={{ fontSize: 18 }}
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              style={{ color: "black" }}
              options={[
                {
                  value: "Manual",
                  id: 1,
                },
                {
                  value: "Automatic",
                  id: 2,
                },
              ]}
              // onChange={(e) => setMachineType(e)}
              onChange={(e) => setMachineType(e.value)}
            />
          </div>
          <InputField
            label={"Recommended Operator"}
            placeholder={"02"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={MachineName}
            onChange={(e) => setMachineName(e.target.value)}
          />
          <Dropdown
            className={styles.inputNew}
            label={"Skill level"}
            value={skillLevel}
            labelStyle={{ fontSize: 18 }}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            style={{ color: "black" }}
            options={[
              {
                value: "Expert",
                id: 1,
              },
            ]}
            onChange={(e) => setSkillLevel(e)}
          />
          <div className={styles.TwoInputRow}>

            {/* ////////////////////left/////////////// */}
            <div >
              <div>
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.weight}
                  text={"Minimum Weight Capacity"}
                />
              </div>
              <div>
                <div className={styles.inputDropdownRow}>
                  <div >
                    <InputField
                      placeholder={"200"}
                      inputStyle={{
                        border: "none"
                      }}
                      innerInput={{}}
                      className={styles.inputNew}
                      value={maxWeightCapacity}
                      onChange={(e) => setMaxWeightCapacity(e.target.value)}
                    /></div>
                  {/* <div >
                    <Dropdown
                      value={maxWeightCapacityUnit}
                      labelStyle={{ fontSize: 18 }}
                      inputStyle={{
                        backgroundColor: "#F7F8F9",
                        border: "none",
                        minWidth: "100px"
                      }}
                      style={{ color: "black" }}
                      options={[
                        {
                          value: "lbs",
                          id: 1,
                        },
                      ]}
                      onChange={(e) => setMaxWeightCapacityUnit(e)}
                    />
                  </div> */}
                </div>
              </div>
            </div>

            {/* ////////////////////right/////////////// */}
            <div >
              <div>
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.weight}
                  text={"Maximum Weight Capacity"}
                />
              </div>
              <div>
                <div className={styles.inputDropdownRow}>
                  <div >
                    <InputField
                      placeholder={"200"}
                      inputStyle={{
                        border: "none"
                      }}
                      innerInput={{}}
                      className={styles.inputNew}
                      value={minWeightCapacity}
                      onChange={(e) => setMinWeightCapacity(e.target.value)}
                    />
                  </div>

                  {/* <div>
                    <Dropdown
                      value={minWeightCapacityUnit}
                      labelStyle={{ fontSize: 18 }}
                      inputStyle={{
                        backgroundColor: "#F7F8F9",
                        border: "none",
                        minWidth: "100px"
                      }}
                      style={{ color: "black" }}
                      options={[
                        {
                          value: "lbs",
                          id: 1,
                        },
                      ]}
                      onChange={(e) => setMinWeightCapacityUnit(e)}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div >
            <InputField
              label={"Maintenance Due(Days)"}
              placeholder={"3"}
              inputStyle={{
                border: "none"
              }}
              innerInput={{}}
              className={styles.inputNew}
              value={dueDay}
              type={"number"}
              onChange={(e) => setDueDay(e.target.value)}
            />
          </div>
          <div style={{ marginTop: "20px", marginBottom: "10px" }}>
            <TextComponent
              fontFamily={"Inter-semiBold"}
              className={styles.weight}
              text={"Station"}
            />
          </div>
          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 2,
              md: 3,
              lg: 3,
              xl: 4,
              xxl: 3,
            }}
            dataSource={data}
            renderItem={item => (
              <List.Item>
                <CheckBox onClick={onChange}>{item.title}</CheckBox>
              </List.Item>
            )}
          />
        </div>

        {MachineType === "Manual" && (
          <div className={styles.rightCont}>
            <div className={styles.TableDiv}>
              <Table
                scroll={{ x: true }}
                columns={manualColumns}
                dataSource={manualList}
                pagination={false}
                rowKey="parameters"
              />
            </div>
            <div>
              <SubmitButton
                title={"Add Parameter"}
                btnClass={styles.paramBtn}
                primary
                btnContainerClass={styles.paramBtnContainer}
                // onClick={() => navigate("/AddEquipment")}
                onClick={() => setIsModal(true)}
              />
            </div>

          </div>

        )}

        {MachineType === "Automatic" && (
          <div className={styles.rightCont}>
            <div className={styles.autoTopCont}>
              <div>
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.programText}
                  text={"Programs"}
                />
              </div>

              <div>
                <SubmitButton
                  title={"Add Program"}
                  btnClass={styles.progBtn}
                  primary
                  btnContainerClass={styles.paramBtnContainer}
                  onClick={handleAddProgram}
                />
              </div>
            </div>


            {programTabs.length > 0 && (
              <div style={{ marginTop: 16 }}>
                {/* Tabs Header */}
                <div className={styles.programTabsContainer}>
                  {programTabs.map((tab) => {
                    const isActive = activeKey === tab.key;
                    return (
                      <div
                        key={tab.key}
                        onClick={() => setActiveKey(tab.key)}
                        className={`${styles.programTab} ${isActive ? styles.programTabActive : ""
                          }`}
                      >
                        <span style={{ fontWeight: 500 }}>{tab.label}</span>
                        {isActive && (
                          <CloseOutlined
                            className={styles.programCloseIcon}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveProgram(tab.key);
                            }}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Active Tab Content */}
                <div className={styles.activeTabContent}>
                  {(() => {
                    const activeProgram = programTabs.find((t) => t.key === activeKey);
                    if (!activeProgram) return null;

                    return (
                      <>
                        <div className={styles.TableDiv}>
                          <Table
                            scroll={{ x: true }}
                            columns={autoColumns}
                            dataSource={activeProgram.tableData}
                            pagination={false}
                            rowKey="parameters"
                          />
                        </div>
                        <div>
                          <SubmitButton
                            title={"Add Parameter"}
                            btnClass={styles.paramBtn}
                            primary
                            btnContainerClass={styles.paramBtnContainer}
                            onClick={() => setIsModal(true)}
                          />
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
            )}

          </div>
        )}
      </div>

      {/* //////////////////////modal Manual  //////////////// */}
      {MachineType === "Manual" && (
        <Modal
          open={isModal}
          onClickOkButton={() => {
            setIsModal(false);
          }}
          onCancel={() => setIsModal(false)}
          className={styles.modalCont}
          title={"Add Parameter (Manual)"}
          headingClass={styles.modalHeading}
          width={"400px"}
          buttonTitle={"Add"}
          btnStyle={{ width: "200px", }}
          onBtnPress={() => setIsModal(false)}

        >
          <div className={styles.modalInnerCont}>
            <div className={styles.modalRow}>

              <div>
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.modalText}
                  text={"Parameter"}
                />
              </div>
              <div>
                <InputField
                  placeholder={"Steam (seconds)"}
                  inputStyle={{
                    border: "none"
                  }}
                  innerInput={{}}
                  className={styles.inputNew}
                  value={manParameter}
                  onChange={(e) => setManParameter(e.target.value)}
                />
              </div>
            </div>

            <div className={styles.modalRow}>
              <div>
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.modalText}
                  text={" Data"}
                /></div>
              <div>
                {/* <InputField
                  placeholder={"Numeric"}
                  inputStyle={{
                    border: "none"
                  }}
                  innerInput={{}}
                  className={styles.inputNew}
                  value={mandata}
                  onChange={(e) => setManData(e.target.value)}
                /> */}
                <Dropdown
                  value={dataType}
                  labelStyle={{ fontSize: 18 }}
                  inputStyle={{
                    backgroundColor: "#F7F8F9",
                    border: "none",
                    minWidth: "200px"
                  }}
                  style={{ color: "black" }}
                  options={[
                    {
                      value: "Numeric",
                      id: 1,
                    },
                    {
                      value: "Text",
                      id: 2,
                    },
                  ]}
                  onChange={(e) => setDataType(e)}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* //////////////////////modal Automatic  //////////////// */}
      {MachineType === "Automatic" && (
        <Modal
          open={isModal}
          onClickOkButton={() => {
            setIsModal(false);
          }}
          onCancel={() => setIsModal(false)}
          className={styles.modalCont}
          title={"Add Parameter (Automatic)"}
          headingClass={styles.modalHeading}
          width={"400px"}
          buttonTitle={"Add"}
          btnStyle={{ width: "200px", }}
          onBtnPress={() => setIsModal(false)}
        >
          <div className={styles.modalInnerCont}>
            <div className={styles.modalRow}>
              <div>
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.modalText}
                  text={"Parameter"}
                />
              </div>
              <div>
                <InputField
                  placeholder={"Steam (seconds)"}
                  inputStyle={{
                    border: "none"
                  }}
                  innerInput={{}}
                  className={styles.inputNew}
                  value={autoParameter}
                  onChange={(e) => setAutoParameter(e.target.value)}
                />
              </div>
            </div>
            <div className={styles.modalRow}>
              <div>
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.modalText}
                  text={" Data"}
                /></div>
              <div>
                {/* <InputField
                  placeholder={"Numeric"}
                  inputStyle={{
                    border: "none"
                  }}
                  innerInput={{}}
                  className={styles.inputNew}
                  value={autoData}
                  onChange={(e) => setAutoData(e.target.value)}
                /> */}
                <Dropdown
                  value={dataType}
                  labelStyle={{ fontSize: 18 }}
                  inputStyle={{
                    backgroundColor: "#F7F8F9",
                    border: "none",
                    minWidth: "200px"
                  }}
                  style={{ color: "black" }}
                  options={[
                    {
                      value: "Numeric",
                      id: 1,
                    },
                    {
                      value: "Text",
                      id: 2,
                    },
                  ]}
                  onChange={(e) => setDataType(e)}
                />
              </div>
            </div>

            <div className={styles.modalRow}>
              <div>
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.modalText}
                  text={" Value"}
                /></div>
              <div>
                <InputField
                  placeholder={"45"}
                  inputStyle={{
                    border: "none"
                  }}
                  innerInput={{}}
                  className={styles.inputNew}
                  value={autoValue}
                  onChange={(e) => setAutoValue(e.target.value)}
                  type={dataType?.value === "Numeric" ? "number" : "text"}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}

    </div>
  )
}

export default EditEquipment
